import type { FunctionComponent } from "preact";
import * as stylex from "@stylexjs/stylex";
import { useState } from "preact/hooks";
import Button, { type ButtonProps } from "./Button.tsx";

const styles = stylex.create({
    container: {
        position: "relative",
    },
    overlay: {
        position: "absolute",
        width: "100%",
        height: "100%",
        cursor: "pointer",
        zIndex: 100,
    },
    actionSheet: {
        gap: "10px",
        display: "none",
        justifyContent: "center",
        position: "absolute",
        width: "100%",
        bottom: 0,
        backgroundColor: "hwb(0 0 100 / .4)",
        padding: "5px",
        zIndex: 101,
    },
    actionSheetVisible: {
        display: "flex",
    },
});

interface ActionSheetProps {
    actions: Array<ButtonProps>;
    onClick?: (() => void) | null;
}

const ActionSheet: FunctionComponent<ActionSheetProps> = ({
    actions,
    onClick = null,
    children,
}) => {
    const [hover, setHover] = useState(false);

    return (
        <div
            {...stylex.props(styles.container)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {onClick ? <div {...stylex.props(styles.overlay)} onClick={onClick}></div> : null}
            <div>{children}</div>
            <div {...stylex.props(styles.actionSheet, hover && styles.actionSheetVisible)}>
                {actions.map((action) => (
                    <Button label={action.label} kind={action.kind} onClick={action.onClick} />
                ))}
            </div>
        </div>
    );
};

export default ActionSheet;
